/**
 *
 * @param {string} input - cpr number input
 * @returns
 */

export default function (cpr) {    
    const pattern = /\b(?<Day>\d{2})(?<Month>\d{2})(?<Year>\d{2})(-?)(?<SequenceNumber>\d{4})\b/
    const match = cpr.match(pattern);

    if (!match) {
        return false;
    }

    const dayPart = parseInt(match.groups["Day"]);
    const monthPart = parseInt(match.groups["Month"]);
    const yearPart = parseInt(match.groups["Year"]);
    const currentYearPart = new Date().getFullYear() % 100;
    
    const year = yearPart <= currentYearPart ? 2000 + yearPart : 1900 + yearPart 

    if (!isValidDate(dayPart, monthPart, year)) {
        return false;
    }
    
    if (year < 2007) {
        return cprMod11Validation(cpr);
    }
    return true;    
}

function isValidDate(day, month, year) {
    const date = new Date(year, month - 1, day); // Month is zero-based
    return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
    );
}

function cprMod11Validation(cpr) {
    const _cprScales = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1]
    const cprWithoutDash = cpr.replace("-", "");
    if (!cprWithoutDash || cprWithoutDash.length !== 10) {
        return false;
    }

    const cprNumber = parseInt(cprWithoutDash);
    if (isNaN(cprNumber)) {
        return false;
    }

    const cprArray = Array.from(cprWithoutDash).map(Number);

    let sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += cprArray[i] * _cprScales[i];
    }

    return sum % 11 === 0;
}
